import { Box, Typography } from "@mui/material";
import { additionalInfo } from "@/utils/staticData/productDetails";

const AdditionalInfo = () => {
  return (
    <Box display="flex" flexDirection="column" gap={4}>
      {additionalInfo.map(({ title, text, iconUrl }, index) => (
        <Box key={index}>
          <Box display="flex" gap={3.75}>
            <img src={iconUrl} alt={title} />
            <Typography variant="h6" component="p" mb={1}>
              {title}
            </Typography>
          </Box>
          <Typography ml={6.75} variant="body1" color="text.secondary">
            {text}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default AdditionalInfo;
